import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { CSVLink } from "react-csv";
import { HiEmojiSad } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom'
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../App.css"
import './loading.css'
import { set, useForm } from 'react-hook-form'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Popup from 'reactjs-popup';
import MoonLoader from "react-spinners/MoonLoader";
import UnauthorizedAccess from './UnauthorizedAccess'

function CManageFSStudents({ IP, TOKEN, UserObj }) {
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [studentList, setStudentList] = useState([])
    const [search, setSearch] = useState("")
    const [filteredList, setFilteredList] = useState([])
    const [rowEdit, setRowEdit] = useState(false)
    const [rowData, setRowData] = useState([])
    const [fsBatches, setFsBatches] = useState([])
    const [selectedBatch, setSelectedBatch] = useState("")
    const [mobile, setMobile] = useState("")

    const keys = ["htno", "name", "college", "mobile", "fsname"] // keys for search    

    // useEffect(() => {
    //     fetchFsBatchNames()
    // }, [])

    const fetchFSBatches = async (college) => {
        await axios.get(`http://${IP}/fs-batch-names/${TOKEN}/${college}`)
            .then(res => {
                setFsBatches(res.data.FSBatches)                
            })
            .catch(err => console.log(err))

    }

    useEffect(() => {
        fetchStudents()
    }, [])

    const fetchStudents = async () => {
        setLoading(true)
        await axios.get(`http://${IP}/fs-students-list/${TOKEN}/${UserObj.college}`)
            .then(res => {
                setFilteredList(res.data.StudentListObj);
                setLoading(false);
                setStudentList(res.data.StudentListObj);
            }
            )
            .catch(err => console.log(err))
    }


    useEffect(() => {
        const data = studentList.filter((Obj) => keys.some((key) => { return Obj[key].toLowerCase().includes(search.toLowerCase()) }))
        setFilteredList(data);
    }, [search])

    //export
    const headers = [
        { label: "RollNo", key: "htno" },
        { label: "StudentName", key: "name" },
        { label: "College", key: "college" },
        { label: "Mobile", key: "mobile" },
        { label: "FSBatchName", key: "fsname" },
        { label: "UpdatedOn", key: "updatedon" }
    ];

    const csvReport = {
        filename: "FS_Students.csv",
        headers: headers,
        data: filteredList
    }

    const rowsSelected = (rows) => {
        // setSeletedRows(rows.selectedRows)
        // console.log(rows.selectedRows)
    }

    const editRow = async (rowData) => {
        setRowData(rowData)
        setMobile(rowData.mobile)
        await axios.get(`http://${IP}/fs-batch-names/${TOKEN}/${rowData.college}`)
            .then(res => {
                setRowEdit(true)
                setFsBatches(res.data.FSBatches)
            })
            .catch(err => console.log(err))
        // notifyWarning("edit")
    }

    const saveChanges = async () => {
        if (mobile === "") {
            notifyError("Mobile should not be empty")
        }
        else if (mobile.length !== 10) {
            notifyError("Mobile length is invalid")
        }
        else if (selectedBatch === "") {
            notifyError("Select FS Batch")
        }
        // else if (rowData.fsbatchid == selectedBatch) {
        //     notifyWarning("No changes found !")
        // }
        else {
            await axios.post(`http://${IP}/update-student-fs-batch/${TOKEN}/${rowData.htno}/${selectedBatch}/${mobile}`)
                .then(res => {
                    if (res.data.error === true) {
                        notifyError(res.data.msg)
                    }
                    else if (res.data.error === false) {
                        notifySuccess(res.data.msg)
                        fetchStudents()
                    }
                    setRowEdit(false)
                })
                .catch(e => console.log(e))
        }
    }

    const deleteRow = async (htno) => {
        await axios.delete(`http://${IP}/delete-fs-student/${TOKEN}/${htno}`)
            .then(res => {
                if (res.data.error == false) {
                    notifySuccess(res.data.msg)
                    fetchStudents()
                }
                else if (res.data.error == true) {
                    notifyError(res.data.msg)
                }
            })
            .catch((err) => console.log(err))
    }

    const columns = [
        {
            name: "Roll No",
            selector: (row) => row.htno,
            sortable: true,
            // width: "150px"
        },
        {
            name: "Student Name",
            selector: (row) => row.name,
            sortable: true,
            // width: "230px"
        },
        // {
        //     name: "College",
        //     selector: (row) => row.college,
        //     sortable: true,
        //     width: "100px"
        // },
        {
            name: "Mobile",
            selector: (row) => <>
                {
                    rowEdit === true && row.htno == rowData.htno ?
                        <input type="text" className="form-control form-control-sm" defaultValue={row.mobile} placeholder="Mobile" onChange={(event) => setMobile(event.target.value)} /> :
                        row.mobile
                }
            </>,
            sortable: true,
        },
        {
            name: "FSBatch Name",
            selector: (row) => <>{
                rowEdit === true && row.htno == rowData.htno ?
                    <select className='form-select form-select-sm' id="FSBatch" onChange={(event) => setSelectedBatch(event.target.value)}>
                        <option defaultChecked value="">Select FS Batch</option>
                        {
                            fsBatches.map(obj => <option value={obj.id} key={obj.id}>{obj.name}</option>)
                        }
                    </select>
                    :
                    row.fsname
            }</>,
            sortable: true,
        },
        {
            name: "Updated On",
            selector: (row) => row.updatedon,
            sortable: true,
            // width: "250px"
        },
        {
            name: "Actions",
            selector: (row) => <>{
                rowEdit === true && rowData.htno == row.htno ?
                    <div>
                        <button className='btn btn-sm btn-success me-2' onClick={() => { saveChanges() }}>Update</button>
                        <button className='btn btn-sm btn-danger me-2' onClick={() => { setRowEdit(false); setRowData([]) }}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button className='btn btn-sm btn-primary me-2' onClick={() => editRow(row)}><AiOutlineEdit className='mb-1' /></button>
                        <Popup trigger={<button className='btn btn-sm btn-danger'><AiOutlineDelete className='mb-1' /></button>} position="top center">
                            <div className='bg-white p-2 text-center rounded popup-delete'>
                                <h6>Are you sure?</h6>
                                <button className='btn btn-sm btn-danger mt-2' onClick={() => deleteRow(row.htno)}>Delete</button>
                            </div>
                        </Popup>
                    </div>
            }</>,
            sortable: false,
        },
    ]

    const [show, setShow] = useState(false);

    const addButton = () => {
        setShow(true)
    }

    const addStudent = async (formData) => {
        await axios.post(`http://${IP}/add-fs-student`, formData)
            .then(res => {
                if (res.data.error === false) {
                    notifySuccess(res.data.msg);
                    setShow(false)
                    fetchStudents()                    
                    setSearch("")
                }
                else if (res.data.error === true) {
                    notifyError(res.data.msg)
                }
            })
            .catch(err => console.log(err))
    }

    const handleClose = () => {
        setShow(false);
    }

    const notifySuccess = (msg) => {
        toast.success(msg, {
            toastId: 1,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    const notifyWarning = (msg) => {
        toast.warn(msg, {
            toastId: 2,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    const notifyError = (msg) => {
        toast.error(msg, {
            toastId: 3,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    return (
        <div className='container-fluid'>
            <Modal show={show} onHide={handleClose} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5 className='text-start'>Add FS student</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className='m-auto m-0 mt-1' onSubmit={handleSubmit(addStudent)}>
                        <div className='row'>
                            <div className='form-group mt-2 col-6'>
                                <label htmlFor='clg'>College</label>
                                <select className='form-select form-select-sm' id="clg" {...register("College", { required: true })} onChange={(e)=>fetchFSBatches(e.target.value)}>
                                    <option value="" defaultChecked>Select college...</option>
                                    <option value="KMIT">KMIT</option>
                                    <option value="NGIT">NGIT</option>
                                    <option value="KMEC">KMEC</option>
                                </select>
                                {errors.College && <span className='text-danger'>College is required</span>}
                            </div>
                            <div className='form-group mt-2 col-6'>
                                <label htmlFor='FSBatch'>FS Batch</label>
                                <select className='form-select form-select-sm' id="FSBatch" {...register("FSBatchId", { required: true })}>
                                    <option defaultChecked value="all">Select FS Batch...</option>
                                    {
                                        fsBatches.map(obj => <option value={obj.id} key={obj.id}>{obj.name}</option>)
                                    }
                                </select>
                                {errors.FSBatch && <span className='text-danger'>FS Batch is required</span>}
                            </div>
                        </div>
                        <div className='form-group mt-2'>
                            <label htmlFor='rno'>Roll No.</label>
                            <input type="text" className='form-control form-control-sm' id="rno" placeholder='roll no.' {...register("RollNo", { required: true })} />
                            {errors.RollNo && <span className='text-danger'>Roll No. is required</span>}
                        </div>
                        <div className='form-group mt-2'>
                            <label htmlFor='sname'>Student Name</label>
                            <input type="text" className='form-control form-control-sm' id="sname" placeholder='student name' {...register("StudentName", { required: true })} />
                            {errors.StudentName && <span className='text-danger'>Student name is required</span>}
                        </div>
                        {/* <div className='form-group mt-2'>
                            <label htmlFor='section'>Section</label>
                            <select className='form-select form-select-sm' id="section" {...register("Section", { required: true })}>
                                <option value="" defaultChecked>Select section...</option>
                                <option value="3-CSE-A">3-CSE-A</option>
                                <option value="3-CSE-B">3-CSE-B</option>
                                <option value="3-CSE-C">3-CSE-C</option>
                                <option value="3-CSE-D">3-CSE-D</option>
                                <option value="3-CSE-E">3-CSE-E</option>
                                <option value="3-CSE-F">3-CSE-F</option>
                                <option value="3-CSE-G">3-CSE-G</option>
                                <option value="3-IT-A">3-IT-A</option>
                                <option value="3-IT-B">3-IT-B</option>
                                <option value="3-CSM-A">3-CSM-A</option>
                                <option value="3-CSM-B">3-CSM-B</option>
                                <option value="3-CSD-A">3-CSD-A</option>
                            </select>
                            {errors.Section && <span className='text-danger'>Section is required</span>}
                        </div> */}
                        <div className='form-group'>
                            <button className='btn btn-success w-100'>Submit</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <div className='m-auto' style={{ maxWidth: "1250px" }}>
                {/* <h6 className='mt-3 pt-2'>Filter By</h6> */}
                {/* <div className='row'>
                    <div className='form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 '>
                        <label htmlFor='PSY' className='me-2'><small>PS Year</small></label>
                        <select className='form-select form-select-sm' id="PSY" onChange={event => setPSYfunction(event.target.value)}>
                            <option defaultChecked value="2022">2022</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                        </select>
                    </div>
                    <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                        <label htmlFor='college' className='me-2'><small>College</small></label>
                        <select className='form-select form-select-sm' id="college" onChange={event => setCollegefunction(event.target.value)}>
                            <option defaultChecked value="all">Select college...</option>
                            {
                                colleges.map(obj => <option value={obj.College}>{obj.College}</option>)
                            }
                        </select>
                    </div>
                    <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                        <label htmlFor='stdyr' className='me-2'><small>Student Year</small></label>
                        <select className='form-select form-select-sm' id="stdyr" onChange={event => setStudentYearfunction(event.target.value)}>
                            <option defaultChecked value="all">Select student year...</option>
                            {
                                studentYears.map(obj => <option value={obj.StudentYear}>{obj.StudentYear}</option>)
                            }
                        </select>
                    </div>
                    <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                        <label htmlFor='sem' className='me-2'><small>Sem</small></label>
                        <select className='form-select form-select-sm' id="sem" onChange={event => setSemfunction(event.target.value)}>
                            <option defaultChecked value="all">Select semester...</option>
                            {
                                semesters.map(obj => <option value={obj.Semester}>{obj.Semester}</option>)
                            }
                        </select>
                    </div>
                    <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                        <label htmlFor='section' className='me-2'><small>Section</small></label>
                        <select className='form-select form-select-sm' id="section" onChange={event => setSectionfunction(event.target.value)}>
                            <option defaultChecked value="all">Select section...</option>
                            {
                                sections.map(obj => <option value={obj.Section}>{obj.Section}</option>)
                            }
                        </select>
                    </div>
                </div> */}
            </div>
            {

                isLoading == true ? (
                    <div>
                        {/* <div className="loader">Loading...</div> */}
                        <h3 className='text-center mt-4'>Loading please wait...</h3>
                        <MoonLoader
                            className='mx-auto moonloader'
                            color="#012951"
                            loading={isLoading}
                            speedMultiplier={1}
                        />
                    </div>
                ) :
                    (<>
                        {studentList.length === 0 ?
                            (<div>
                                <h5 className='text-center mt-5'><HiEmojiSad /> Oops... No Data Found </h5>
                            </div>
                            ) : (
                                <div className='data-table-manage-students-list'>
                                    {/* <h5 className='text-start pt-1'>{selectedPSY} students list</h5> */}
                                    {/* <nav>
                                        <small>
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item active d-inline">Showing results of -&gt; {selectedPSY}</li>
                                                {
                                                    selectedCollege != "" &&
                                                    <li className="breadcrumb-item active d-inline">{selectedCollege.toLowerCase()}</li>
                                                }
                                                {
                                                    selectedStdyr != "" &&
                                                    <li className="breadcrumb-item active d-inline">{selectedStdyr}year</li>
                                                }
                                                {
                                                    selectedSem != "" &&
                                                    <li className="breadcrumb-item active d-inline">{selectedSem.toLowerCase()}</li>
                                                }
                                                {
                                                    selectedSection != "" &&
                                                    <li className="breadcrumb-item active d-inline">{selectedSection.toLowerCase()}</li>
                                                }
                                            </ol>
                                        </small>
                                    </nav> */}
                                    <DataTable
                                        title='FS Students'
                                        columns={columns}
                                        data={filteredList}
                                        // onRowClicked={handleSelectedRow}
                                        // pointerOnHover
                                        pagination
                                        // selectableRows
                                        // selectableRowsHighlight
                                        // onSelectedRowsChange={rowsSelected}
                                        defaultSortFieldId={1}
                                        fixedHeader
                                        fixedHeaderScrollHeight='600px'
                                        highlightOnHover
                                        actions={<CSVLink {...csvReport}><button className='btn btn-sm btn-primary m-0'>Export</button></CSVLink>}
                                        subHeader
                                        subHeaderComponent={
                                            <>
                                                <button className='btn btn-sm btn-primary mb-1 me-md-2' onClick={addButton}>Add</button>
                                                <input type="text" className='form-control form-control-sm datatable-search' placeholder='Search here...' value={search} onChange={(e) => setSearch(e.target.value)} />
                                            </>
                                        } />
                                </div>
                            )
                        }
                    </>)
            }
            <ToastContainer />
        </div>
    );
}

export default CManageFSStudents;